import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { BasketService } from '@df/session/api/basket/basket.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';

export interface IMinibasketModalData {
    autoOpened?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MinibasketInitiatorService extends AbstractDfModalInitiatorService<IMinibasketModalData> {
    constructor(
        dfModalService: DfModalService,
        app: App,
        private basketService: BasketService
    ) {
        super(dfModalService, app);
    }

    listen(cb: (D: IMinibasketModalData) => void): Promise<void> {
        return new Promise(resolve => {
            this.basketService.subscribeToAddToBasketSuccess(eventData => {
                if (!eventData.response?.preventMinibasketOpen) {
                    cb({
                        autoOpened: true
                    });
                }
            });
            resolve();
        });
    }
}
